import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'shared/utils/toast';
import { purchaseRequestService } from '../api/purchase-request.service';
import { PurchaseAutomaticLineColumns } from '../purchase-request-automatic';

export const PurchaseRequestAutomaticList = () => {
  const translationPrefix = 'pages.purchase-requests.automatic.list';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = PurchaseAutomaticLineColumns();

  const preCompile = () => {
    toast.success(t(`${translationPrefix}.calculate-rda-started`));
    purchaseRequestService.preCompile().then(() => {
      toast.success(t(`${translationPrefix}.calculate-rda-success`));
      datagridRefresh.current();
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <Button variant="outlined" onClick={preCompile}>
          {t(`${translationPrefix}.calculate-rda`)}
        </Button>
      }>
      <EnhancedDataGrid
        columns={columns}
        service={purchaseRequestService}
        refresh={datagridRefresh}
        outerParams={{
          automatic_generated: true
        }}
      />
    </TenantPage>
  );
};

export default PurchaseRequestAutomaticList;
